import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { from, Observable, of } from 'rxjs';
import { App, AppInfo } from '@capacitor/app';
import { map } from 'rxjs/operators';
import { API_PATHS_TOKEN, BackendType, BASE_URL_TOKEN, CAPACITOR_TOKEN } from '@raptor-fe/core';

@Injectable({ providedIn: 'root' })
export class AppService {
    /**
     * Contains information about the app, including name, builder and version information.
     *
     * set to an empty observe on web to avoid an error
     */
    appInfo$: Observable<AppInfo>;

    private readonly http = inject(HttpClient);
    private readonly capacitorGlobal = inject(CAPACITOR_TOKEN);
    private readonly base_url = inject(BASE_URL_TOKEN);
    private readonly apiPaths = inject(API_PATHS_TOKEN);

    constructor() {
        this.appInfo$ = this.capacitorGlobal.isNativePlatform()
            ? from(App.getInfo())
            : of({ name: '', id: '', build: '', version: 'debug' });
    }

    /**
     * Validate the given server URL by sending a POST request to the server.
     *
     * @param {string} serverUrl The server URL to be validated.
     *
     * @return {Observable<string>} An Observable that contains a backend inticator, blue, GTX or TireMaster.
     */
    validateUrl(serverUrl: string): Observable<BackendType> {
        const body: { url: string } = {
            url: serverUrl,
        };
        return this.http
            .post<{ backendType: BackendType }>(
                `${this.base_url}${this.apiPaths['validateUrl']}`,
                body,
            )
            .pipe(map((response) => response.backendType));
    }
}
